import React, {
  useEffect, useMemo, useRef, useState
} from 'react';
import PropTypes from 'prop-types';
import { Flex } from 'onefaceui-react-components';

import { getStopHoverPosition } from 'react/utils/stopBoxUtils';

import { getIsBlockedComplianceByStatues } from 'react/utils/utils';
import Arrow from './Arrow';
import HeaderCard from './Header';
import TimeWindowsTable from './TimeWindowsTable';
import TimesDeliveryTable from './TimesDeliveryTable';
import SizesTable from './SizesTable';

import { Container } from './styles';
import DriverInfor from './DriverInfo';

const DEFAULT_POSITION = {
  top: 0,
  left: 0,
  align: 'center',
  side: 'top'
};

function StopHoverCard(props) {
  const containerRef = useRef(null);
  const openTimerRef = useRef(0);
  const [position, setPosition] = useState(DEFAULT_POSITION);
  const [isVisible, setIsVisible] = useState(false);

  const {
    stopData, boundStop: { x, y }, frozenColumnsWidth, testId
  } = props;

  const isBlockedStatus = useMemo(() => getIsBlockedComplianceByStatues({
    status: stopData.status,
    statusClass: stopData.statusClass
  }), [stopData]);

  useEffect(() => {
    if (containerRef.current) {
      setPosition(getStopHoverPosition(x, y, frozenColumnsWidth));
      openTimerRef.current = window.setTimeout(() => setIsVisible(true), 700);
    }

    return () => {
      setIsVisible(false);
      clearTimeout(openTimerRef.current);
    };
  }, [containerRef]);

  return (
    <Container
      data-testid={testId}
      ref={containerRef}
      style={{
        top: position.top,
        left: position.left,
        visibility: isVisible ? 'visible' : 'hidden'
      }}
    >
      <Flex gap={4} flexDirection="column">
        <HeaderCard stopData={stopData} isBlocked={isBlockedStatus} />
        <TimeWindowsTable stopData={stopData} isBlocked={isBlockedStatus} />
        <TimesDeliveryTable stopData={stopData} isBlocked={isBlockedStatus} />
        <SizesTable stopData={stopData} />
        <DriverInfor stopData={stopData} />
      </Flex>
      <Arrow side={position.side} align={position.align} />
    </Container>
  );
}

StopHoverCard.propTypes = {
  testId: PropTypes.string,
  stopData: PropTypes.object.isRequired,
  boundStop: PropTypes.object.isRequired,
  frozenColumnsWidth: PropTypes.number
};

StopHoverCard.defaultProps = {
  testId: 'stop-hover-card',
  frozenColumnsWidth: 0
};

export default StopHoverCard;
